import {Link} from 'react-router-dom';
import classNames from 'classnames';
import {SoopButtonCommon} from '@soop-ui/soop-ui';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';
import {useAutoCloseDialog} from '@/hooks/help';
import {InquiryItemProps} from '@/components/help/mobile/my-inquiry/InquiryItem';
import {ROUTE} from '@/constants/main/route';
import {HELP_LOG} from '@/constants/help';
import {sendHelpClickLog} from '@/utils/help/log';
import styles from './InquiryItem.module.scss';
import SurveyLayer from '../SurveyLayer';

const InquiryItem = ({
  id,
  title,
  type,
  createdDate,
  isAnswered,
  isEvaluated,
  status,
  onSurveySuccess,
}: InquiryItemProps) => {
  const {isMobile} = useHelpContext();
  const {openDialog} = useAutoCloseDialog();
  const handleOpenSurveyLayer = () => {
    openDialog({
      component: () => (
        <SurveyLayer
          isMobile={isMobile}
          inquiryId={id}
          onSuccess={onSurveySuccess}
        />
      ),
      scrollLock: true,
    });
    sendHelpClickLog(HELP_LOG.CODE_TYPE.INQUIRY, {
      buttonType: HELP_LOG.BUTTON_TYPE.MY_FEEDBACK,
    });
  };

  return (
    <li className={styles.ListWrapper}>
      <div className={styles.ListType}>{type}</div>
      <div className={styles.ListTitle}>
        <Link to={`${ROUTE.HELP.MY_INQUIRY}/${id}`}>
          <em>Q</em>
          {title}
        </Link>
        <div className={styles.ResponsiveArea}>
          <span>{type}</span>
          <span>{createdDate}</span>
        </div>
      </div>
      <div
        className={classNames(styles.ListAnswer, {
          [styles.AnswerComplete]: isAnswered,
        })}>
        {status}
      </div>

      <div
        className={classNames(styles.ListEvaluation, {
          [styles.EvalButton]: !isEvaluated && isAnswered,
        })}>
        {isEvaluated ? (
          '평가완료'
        ) : isAnswered ? (
          <SoopButtonCommon
            variant='defaultPrimary'
            size={28}
            onClick={handleOpenSurveyLayer}>
            답변 평가
          </SoopButtonCommon>
        ) : (
          '-'
        )}
      </div>
      <div className={styles.ListDate}>{createdDate}</div>
    </li>
  );
};

export default InquiryItem;
